import { render, staticRenderFns } from "./ProgramTransfer.vue?vue&type=template&id=0f8e9bba&scoped=true"
import script from "./ProgramTransfer.vue?vue&type=script&lang=js"
export * from "./ProgramTransfer.vue?vue&type=script&lang=js"
import style0 from "./ProgramTransfer.vue?vue&type=style&index=0&id=0f8e9bba&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f8e9bba",
  null
  
)

export default component.exports